export const DownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.6667 5.66699L7.99999 10.3337L3.33333 5.66699"
      stroke="#40495C"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
